import { createContext, useContext, type PropsWithChildren } from "react";
import type { M2UserApi } from "../data/M2UserApi";

const UserApiContext = createContext<M2UserApi | null>(null);
export function UserStoreProvider({ api, children }: PropsWithChildren<{ api: M2UserApi }>) { return <UserApiContext.Provider value={api}>{children}</UserApiContext.Provider>; }
export function useUserApi() { const api = useContext(UserApiContext); if (!api) throw new Error("useUserApi 必须在 UserStoreProvider 内使用"); return api; }
